import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@gemini/ui";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
/**
 * @param label
 * @param onPress
 * @param icon
 * @param isOver - position of the CTA above an image or not
 * @returns a Gemini Button
 */
export const TopBarCTA = ({ isOver, label, onPress, icon }) => {
    const isPreviewMode = useIsPreviewMode();
    return (_jsx(Button, { variant: isOver ? "secondary-floating" : "tertiary", iconOnly: true, icon: icon, size: "40", onPress: onPress, isDisabled: isPreviewMode, children: label }));
};
